import React from 'react';
import colorWheel from '../../../../Theme/ColorWheel';

declare type TextClassName = 'defaultCopy' | 'infoCallOut' | 'tinyHeadline';
interface ILabelText {
    label?: string | React.ReactNode,
    dataAttr?: string,
    title?: string,
    isBold?: boolean
    textClassName?: TextClassName;
}

const LabelText: React.FC<ILabelText> = props => {
    const { label, dataAttr, title, isBold, textClassName } = props;
    return <p className={textClassName || 'defaultCopy'} style={{ fontWeight: isBold ? 500 : 400, color: colorWheel.black}} title={title} data-label={dataAttr || 'labelText'}>
        {label}
    </p>
}
export default LabelText;
